import { Component, OnInit, ViewChild, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

import { ROUTES } from './sidebar-routes.config';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { customAnimations } from '../animations/custom-animations';
import { ConfigService } from '../services/config.service';
import { UserSessionService } from 'services/usersession.service';
import { ApplicationService } from 'services/application.service';
import { ActiveUserSession } from 'models/activeusersession';
import { ActiveUserSessionService } from 'services/activeusersession.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  animations: customAnimations
})
export class SidebarComponent implements OnInit, AfterViewInit {

  @ViewChild('toggleIcon', { static: false }) toggleIcon: ElementRef;
  public menuItems: any[];
  depth: number;
  activeTitle: string;
  activeTitles: string[] = [];
  expanded: boolean;
  nav_collapsed_open = false;
  logoUrl = 'assets/img/logo.png';
  public config: any = {};
  roleId: any;
  usersession: any;
  isAlreadyMO: boolean = false;
  applicationList: any[];
  applicationValue: any;
  applicationResult: any;
  isAllowFriendMenu: boolean;


  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private configService: ConfigService,
    private userSessionService: UserSessionService,
    private applicationService: ApplicationService,
    private activeusersessionservice: ActiveUserSessionService,
  ) {

    this.usersession = this.userSessionService.getUserSession();



    this.roleId = this.userSessionService.roleId();
    this.getApplicationSubCategory(false);

    if (this.depth === undefined) {
      this.depth = 0;
      this.expanded = true;
    }
  }

  ngOnInit() {

    this.config = this.configService.templateConf;



    // if (this.roleId == 1) {
    //   this.menuItems = this.menuItems.filter(item => {
    //     return item.roleType[0].includes('Customer')
    //   });
    // }
    // else if (this.roleId == 2) {
    //   this.menuItems = this.menuItems.filter(item => {
    //     return item.roleType[0].includes('Admin')
    //   });
    // }

    if (this.roleId == 2) {
      this.menuItems = ROUTES;
      this.menuItems = this.menuItems.filter(item => {
        return item.roleType[0].includes('SuperAdmin')
      });

      this.activeusersessionservice.createRolePage(this.menuItems);
    }

    if (this.roleId == 3) {
      this.menuItems = ROUTES;
      this.menuItems = this.menuItems.filter(item => {
        return item.roleType[0].includes('_Admin')
      });
      this.activeusersessionservice.createRolePage(this.menuItems);
    }

    if (this.roleId == 4) {
      this.menuItems = ROUTES.filter(item => {
        return item.roleType[0].includes('Reseller');
      });
      this.activeusersessionservice.createRolePage(this.menuItems);
    }


    if (this.config.layout.sidebar.backgroundColor === 'white') {
      this.logoUrl = 'assets/img/logo-dark.png';
    } else {
      this.logoUrl = 'assets/img/logo.png';
    }


  }

  ngAfterViewInit() {

    setTimeout(() => {
      if (this.config.layout.sidebar.collapsed !== undefined) {
        if (this.config.layout.sidebar.collapsed === true) {
          this.expanded = false;
          this.renderer.addClass(this.toggleIcon.nativeElement, 'ft-toggle-left');
          this.renderer.removeClass(this.toggleIcon.nativeElement, 'ft-toggle-right');
          this.nav_collapsed_open = true;
        } else if (this.config.layout.sidebar.collapsed === false) {
          this.expanded = true;
          this.renderer.removeClass(this.toggleIcon.nativeElement, 'ft-toggle-left');
          this.renderer.addClass(this.toggleIcon.nativeElement, 'ft-toggle-right');
          this.nav_collapsed_open = false;
        }
      }
    }, 0);
  }

  toggleSlideInOut(menu) {

    if (menu.title == 'Manage Order' || this.isAlreadyMO) {

      this.isAlreadyMO = menu.title == 'Manage Order' ? true : false;

      setTimeout(() => {
        let el: HTMLElement = this.toggleIcon.nativeElement;
        el.click();
        if (this.config.layout.sidebar.collapsed !== undefined) {
          if (this.config.layout.sidebar.collapsed === false) {
            this.expanded = false;
            this.renderer.addClass(this.toggleIcon.nativeElement, 'ft-toggle-left');
            this.renderer.removeClass(this.toggleIcon.nativeElement, 'ft-toggle-right');
            this.nav_collapsed_open = true;
          }
        }
      }, 0);
    }


  }

  handleToggle(titles) {
    this.activeTitles = titles;
  }

  // NGX Wizard - skip url change
  ngxWizardFunction(path: string) {
    if (path.indexOf('forms/ngx') !== -1) {
      this.router.navigate(['forms/ngx/wizard'], { skipLocationChange: false });
    }
  }


  getApplicationSubCategory(refresh) {
    debugger
    this.applicationService.getApplicationSubCategory(refresh).subscribe(result => {

      this.applicationResult = result;

      if (this.roleId == 1) {

        if (this.applicationResult.value == 'BothCategory') {
          this.menuItems = ROUTES;
          this.menuItems = this.menuItems.filter(item => {
            return item.roleType[0].includes('BothCategory')
          });
          this.menuItems.forEach(element => {
            element.submenu = element.submenu.filter(item => {
              return item.roleType[0].includes('BothCategory')
            });

          });
        }
        else if (this.applicationResult.value == 'Recurring') {
          this.menuItems = ROUTES;
          this.menuItems = this.menuItems.filter(item => {
            return item.roleType[0].includes('Recurring')
          });
          this.menuItems.forEach(element => {
            element.submenu = element.submenu.filter(item => {
              return item.roleType[0].includes('Recurring')
            });

          });
        }
        else if (this.applicationResult.value == 'Once-Off') {
          this.menuItems = ROUTES;
          this.menuItems = this.menuItems.filter(item => {
            return item.roleType[0].includes('Once-Off')
          });
          this.menuItems.forEach(element => {
            element.submenu = element.submenu.filter(item => {
              return item.roleType[0].includes('Once-Off')
            });

          });

        }
        else if (this.applicationResult.value == "BothActiveCustomer") {
          this.menuItems = ROUTES;
          this.menuItems = this.menuItems.filter((item) => {
            return item.roleType[0].includes("BothActiveCustomer");
          });
          this.menuItems.forEach((element) => {
            element.submenu = element.submenu.filter((item) => {
              return item.roleType[0].includes("BothActiveCustomer");
            });
          });
        }
        else if (this.applicationResult.value == "RecurrActiveCustomer") {
          this.menuItems = ROUTES;
          this.menuItems = this.menuItems.filter((item) => {
            return item.roleType[0].includes("RecurrActiveCustomer");
          });
          this.menuItems.forEach((element) => {
            element.submenu = element.submenu.filter((item) => {
              return item.roleType[0].includes("RecurrActiveCustomer");
            });
          });
        }
        else if (this.applicationResult.value == "OnceOffActiveCustomer") {
          this.menuItems = ROUTES;
          this.menuItems = this.menuItems.filter((item) => {
            return item.roleType[0].includes("OnceOffActiveCustomer");
          });
          this.menuItems.forEach((element) => {
            element.submenu = element.submenu.filter((item) => {
              return item.roleType[0].includes("OnceOffActiveCustomer");
            });
          });
        }
        else {
          this.menuItems = ROUTES;
          this.menuItems = this.menuItems.filter(item => {
            return item.roleType[0].includes('Customer')
          });
          this.menuItems.forEach(element => {
            element.submenu = element.submenu.filter(item => {
              return item.roleType[0].includes('Customer')
            });

          });
        }

        // this.isAllowFriendMenu = this.activeusersessionservice.getIsAllowFriendMenu();

        // if (!this.isAllowFriendMenu) {
        //   this.menuItems = this.menuItems.filter(item => {
        //     return item.path != '/referfriends'
        //   });

        // }

        this.activeusersessionservice.createRolePage(this.menuItems);



        // this.applicationList.forEach(item_value => {
        //   this.menuItems = ROUTES;
        //       if (item_value.subCategoryId == 1) {

        //         this.menuItems = this.menuItems.filter(item => {
        //           return item.roleType[0].includes('Once-Off')
        //         });
        //       }
        //       else if (item_value.subCategoryId == 2) {
        //         this.menuItems = this.menuItems.filter(item => {
        //           return item.roleType[0].includes('Recurring')
        //         });
        //       }
        //       else{
        //         this.menuItems = this.menuItems.filter(item => {
        //           return item.roleType[0].includes('Customer')
        //         });
        //       }

        //     });



      }

    });
  }
}
